import { AttemptsCorrectionShow } from 'pages/professor_area/classrooms/components/TabEvaluations/Evaluation/components/TabAttempts/Attempts/AttemptsCorrection/AttempsCorrectionShow';
import { AttemptsShow } from 'pages/professor_area/classrooms/components/TabEvaluations/Evaluation/components/TabAttempts/Attempts/AttemptsShow';
import { IResource } from 'interfaces/resources';
import { generateResources } from 'utils/GenerateResouces';

const resource: IResource = {
  name: 'professor_area/classroom_assessments/attempts',
  pathTemplate:
    'professor_area/classrooms/:classroomId/evaluations/:evaluationId/attempts',
  label: 'Avaliação do aluno',
  show: AttemptsShow,
  edit: AttemptsCorrectionShow,
  actions: ['list', 'show', 'edit'],
  parentName: 'professor_area',
  route:
    'professor_area/classrooms/:classroomId/assessments/:evaluationId/attempt'
};

export default generateResources(resource);
